module.exports = "/images/14K.webp?a4dc1a7336341cac27c9ad27f82858aa";